import { React, PropTypes, styled } from '../lib/imports';
import { useCdnUrl } from '../app/context/config';
import { Heading, Image, ShadowBox, Text } from '../components';
import { useSelector } from 'react-redux';

const Container = styled(ShadowBox)`
  padding: ${({ theme }) => theme.spacings.giga};
  margin: 0 auto;

  color: ${({ theme }) => theme.colors.white};
`;

const CardHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  line-height: ${({ theme }) => theme.typography.subHeadings.mega.lineHeight};
  letter-spacing: ${({ theme }) => theme.typography.subHeadings.mega.letterSpacing};
  align-items: center;
  margin-top: ${({ theme }) => theme.spacings.bit};
`;
const Badge = styled.span`
  font-family: 'Brewed-Bold';
  background-color: ${(props) => props.theme.colors[props.color]};
  border-radius: 12px;
  font-size: 12px;
  font-weight: 800;
  padding: ${({ theme }) => `${theme.spacings.bit} ${theme.spacings.kilo}`};
`;

const Title = styled(Heading)`
  flex-grow: 1;
  font-size: 18px;
  font-weight: 800;
  width: 50%;
`;

const SponsorSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  border-bottom: ${(props) => (props.hasDivider ? '1px solid rgba(255,255,255,0.3)' : '')};
  margin-top: ${(props) => (props.spacingTop ? '28px' : props.spacingTopSmall ? '10px' : '')};
`;

const LogoContainer = styled.div`
  width: ${(props) => `${props.width}`};
  padding: ${(props) =>
    props.noPadding
      ? `0px 0px ${props.theme.spacings.giga}`
      : `${props.theme.spacings.giga} ${props.theme.spacings.giga}`};
`;

const SponsorLogo = styled(Image)``;

const SponsorDesc = styled(Text)`
  text-align: center;
  span {
    font-family: 'Brewed-Bold';
    display: block;
    margin: ${({ theme }) => theme.spacings.atom} ${({ theme }) => theme.spacings.kilo};
    font-weight: 900;
    font-size: ${({ theme }) => theme.typography.subHeadings.tera.fontSize};
    line-height: ${({ theme }) => theme.typography.subHeadings.tera.lineHeight};
    letter-spacing: -1.5px;
    padding-bottom: ${({ theme }) => theme.spacings.giga};
    sup {
      font-size: ${({ theme }) => theme.typography.headings.deca.fontSize};
    }
  }
`;

const ChallengeCard = ({
  title,
  dates,
  logosSrc,
  logoSrc,
  sponsorText,
  children,
  background,
  hasDivider,
  spacingTop,
  spacingTopSmall,
  noPadding,
  active,
  noBadge,
}) => {
  const cdnUrl = useCdnUrl();
  const { strings } = useSelector((state) => state);
  const inProgressText = strings['challenges/inProgress/text'];
  const completedText = strings['challenges/completed/text'];
  return (
    <Container background={background}>
      <CardHeader>
        <Title as='h4' noMarginTop noMarginBottom>
          {title}
        </Title>
        {!noBadge &&
          (active ? <Badge color='g600'>{inProgressText}</Badge> : <Badge color='n900'>{completedText}</Badge>)}{' '}
      </CardHeader>
      <SponsorSection hasDivider={hasDivider} spacingTop={spacingTop} spacingTopSmall={spacingTopSmall}>
        {logosSrc?.length > 0 &&
          logosSrc.map((logo, i) => (
            <LogoContainer key={`sponsor-${i}`} width={logo.width} noPadding={noPadding}>
              <SponsorLogo src={`${cdnUrl}${logo.src}`} />
            </LogoContainer>
          ))}
        <SponsorDesc size='tera' noMargin>
          {sponsorText}
        </SponsorDesc>
      </SponsorSection>

      {children}
    </Container>
  );
};

ChallengeCard.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  background: PropTypes.string,
  title: PropTypes.string,
  dates: PropTypes.string,
  logosSrc: PropTypes.array,
  sponsorText: PropTypes.string,
  active: PropTypes.bool,
  noBadge: PropTypes.bool,
};

export default ChallengeCard;
